module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "sidebar",
    attrs: {
      "data-color": "blue",
      "data-image": "../assets/img/sidebar-5.jpg"
    }
  }, [_c('div', {
    staticClass: "sidebar-wrapper"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "simple-text logo-mini",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("R")]), _vm._v(" "), _c('a', {
    staticClass: "simple-text logo-normal",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("RAEFTON")])]), _vm._v(" "), _c('div', {
    staticClass: "user border-0"
  }, [_c('div', {
    staticClass: "info ml-4"
  }, [_vm._v("\n            Ryan Sweny\n          ")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/raw_templates/t_dashboard"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-delivery-fast"
  }), _vm._v(" "), _c('p', [_vm._v("RFQs")])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item "
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/raw_templates/t_createrfq"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-paper-2"
  }), _vm._v(" "), _c('p', [_vm._v("CREATE RFQ")])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item "
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/raw_templates/t_contacts"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-circle-09"
  }), _vm._v(" "), _c('p', [_vm._v("CONTACTS")])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item "
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/raw_templates/t_contacts"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-button-power"
  }), _vm._v(" "), _c('p', [_vm._v("SIGN OUT")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-background",
    staticStyle: {
      "background-image": "url(/static/img/sidebar-5.jpg)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-lg "
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-wrapper"
  }, [_c('div', {
    staticClass: "navbar-minimize"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-fill btn-round btn-icon d-none d-lg-block",
    attrs: {
      "id": "minimizeSidebar"
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v visible-on-sidebar-regular"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-navicon visible-on-sidebar-mini"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#pablo",
      "id": "test"
    }
  }, [_vm._v(" RFQs")])]), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "aria-controls": "navigation-index",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  }), _vm._v(" "), _c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  }), _vm._v(" "), _c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card data-tables"
  }, [_c('div', {
    staticClass: "card-body table-striped table-no-bordered table-hover dataTable dtr-inline table-full-width"
  }, [_c('div', {
    staticClass: "toolbar"
  }), _vm._v(" "), _c('div', {
    staticClass: "fresh-datatables"
  }, [_c('table', {
    staticClass: "table table-striped table-no-bordered table-hover",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "datatables",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "disabled-sorting"
  }), _vm._v(" "), _c('th', [_vm._v("Customer")]), _vm._v(" "), _c('th', [_vm._v("Shipper")]), _vm._v(" "), _c('th', [_vm._v("Consignee")]), _vm._v(" "), _c('th', [_vm._v("Created Date")]), _vm._v(" "), _c('th', [_vm._v("Due Date")]), _vm._v(" "), _c('th', {
    staticClass: "disabled-sorting"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "disabled-sorting text-right"
  }, [_vm._v("Actions")])])])])])])])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', [_c('p', {
    staticClass: "copyright text-center"
  }, [_vm._v("\n            © 2018 Raefton\n          ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54b0d9aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/raw_templates/t_dashboard.vue
// module id = 712
// module chunks = 0